import Swal from "sweetalert2";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../action-types";
import { getAPI, postAPI } from "../../utils/api-function";
import { get_revenue_settings, update_revenue_settings, get_revenue_records } from "../../utils/api-routes";

function* getRevenueSettingsSaga() {
    try {
        const response = yield call(getAPI, get_revenue_settings);
        if (response?.data?.status) {
            yield put({ type: actionTypes.SET_REVENUE_SETTINGS, payload: response.data.result });
        }
    } catch (error) {
        console.log("Get Revenue Settings Error:", error);
    }
}

function* updateRevenueSettingsSaga(action) {
    try {
        const { data, onComplete } = action.payload;
        const response = yield call(postAPI, update_revenue_settings, data);
        if (response?.data?.status) {
            yield put({ type: actionTypes.SET_REVENUE_SETTINGS, payload: response.data.result });
            Swal.fire({ icon: "success", title: "Success", text: "Revenue settings updated successfully" });
            if (onComplete) yield call(onComplete);
        } else {
            Swal.fire({ icon: "error", title: "Error", text: response?.data?.message || "Failed to update settings" });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: error?.response?.data?.message || error?.message || "Something went wrong" });
    }
}

function* getRevenueRecordsSaga(action) {
    try {
        const params = action.payload || {};
        const route = get_revenue_records(params);
        const response = yield call(getAPI, route);
        if (response?.data?.status) {
            const result = response.data.result;
            yield put({ type: actionTypes.SET_REVENUE_RECORDS, payload: { records: result.records, summary: result.summary } });
        } else {
            yield put({ type: actionTypes.SET_REVENUE_RECORDS, payload: { records: [], summary: {} } });
        }
    } catch (error) {
        console.log("Get Revenue Records Error:", error);
        yield put({ type: actionTypes.SET_REVENUE_RECORDS, payload: { records: [], summary: {} } });
    }
}

export default function* revenueSaga() {
    yield takeLatest(actionTypes.GET_REVENUE_SETTINGS, getRevenueSettingsSaga);
    yield takeLatest(actionTypes.UPDATE_REVENUE_SETTINGS, updateRevenueSettingsSaga);
    yield takeLatest(actionTypes.GET_REVENUE_RECORDS, getRevenueRecordsSaga);
}
